import createPerSliceIdSelector from '../helpers/createPerSliceIdSelector';
import get from '../helpers/get';
import { getSliceItems } from './content';

// eslint-disable-next-line import/prefer-default-export -- because we re-export from ./index.js
export const getTiles = createPerSliceIdSelector(
  getSliceItems,
  items => items.map(content => ({
    title: get(content, ['title']),
    copy: get(content, ['copy']),
    moreInfo: content.info,
    heroImage: content.hero_image,
  })),
);
